/**
 * API-Client für /api/regions (Phase B, Kapitel 1.2.2 / 20.2).
 *
 * Region ist ein rein beschreibendes Label für Standorte einer Firma — kein
 * eigener Verwaltungs-Screen (Kapitel 20.2), sondern nur ein Dropdown im
 * bestehenden Standort-Formular (siehe LocationsAdminPage.tsx).
 */

import { apiFetch } from './api';

export interface ApiRegion {
  id: string;
  companyId: string;
  name: string;
  locationCount: number;
  createdAt: string;
}

export const regionsApi = {
  list: (token: string) =>
    apiFetch<{ regions: ApiRegion[] }>('/api/regions', { token }).then((r) => r.regions),

  create: (token: string, name: string) =>
    apiFetch<{ region: ApiRegion }>('/api/regions', { method: 'POST', body: { name }, token }).then(
      (r) => r.region,
    ),

  rename: (token: string, id: string, name: string) =>
    apiFetch<{ region: ApiRegion }>(`/api/regions/${id}`, {
      method: 'PUT',
      body: { name },
      token,
    }).then((r) => r.region),

  remove: (token: string, id: string) => apiFetch<void>(`/api/regions/${id}`, { method: 'DELETE', token }),
};
